var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTricolor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77.852654mm",
    height: "77.852669mm",
    viewBox: "0 0 77.852654 77.852669",
    id: "svg1002",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-66.073679,-109.57369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1122",
    transform: "matrix(9.3002806,0,0,9.3002806,-572.8753,-1251.5975)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#261f33",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0180417,
      strokeLinecap: "round",
      strokeMiterlimit: 2,
      strokeDasharray: "none"
    },
    id: "rect25307-6-7-1-2-6-9-8-7",
    width: 8.3710003,
    height: 8.3710003,
    x: 68.702118,
    y: 146.35808,
    ry: 0.45413378
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9611a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0181549,
      strokeLinecap: "round",
      strokeMiterlimit: 2,
      strokeDasharray: "none"
    },
    d: "m 69.137322,152.61378 3e-5,0.55358 3e-5,0.59089 c 0.007,0.59501 -0.008,0.5865 0.59161,0.58985 l 2.99895,1.6e-4 2.9921,1.4e-4 c 0.49347,7e-5 0.53536,-0.12849 0.28879,-0.40997 l -1.48966,-1.37729 -1.46415,-1.42848 c -0.29763,-0.29584 -0.35499,-0.32029 -0.75602,-0.18452 l -1.37044,0.46397 -1.23101,0.41672 c -0.60308,0.19092 -0.56027,0.1332 -0.56023,0.78495 z",
    id: "path24193-5-5-0-2-5-5-2-6-3-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec8725",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0177525,
      strokeLinecap: "round",
      strokeMiterlimit: 2,
      strokeDasharray: "none"
    },
    d: "m 69.137322,152.53728 3e-5,0.52931 3e-5,0.56499 c 0.007,0.56892 -0.008,0.56078 0.59161,0.56397 l 2.99895,1.6e-4 2.9921,1.4e-4 c 0.49347,7e-5 0.4507,-0.10375 0.17502,-0.40212 l -1.37589,-1.30679 -1.46415,-1.36585 c -0.29763,-0.28287 -0.35499,-0.30625 -0.75602,-0.17643 l -1.37044,0.44362 -1.23101,0.39845 c -0.60308,0.18255 -0.56027,0.12737 -0.56023,0.75055 z",
    id: "path24193-5-5-0-2-5-5-3-8-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61368b",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0183759,
      strokeLinecap: "round",
      strokeMiterlimit: 2,
      strokeDasharray: "none"
    },
    d: "m 73.679462,147.38872 -0.89654,2.68471 c -0.15097,0.37454 -0.18515,0.43017 -0.54985,0.55401 l -2.52304,0.8568 c -0.61125,0.16811 -0.56356,0.0631 -0.57035,-0.40614 l -2.7e-4,-3.652 c 0.005,-0.64082 0.0126,-0.58923 0.59832,-0.60113 l 3.53162,-0.003 c 0.42767,-3.9e-4 0.58111,0.0127 0.41011,0.56738 z",
    id: "path24191-5-4-2-99-0-9-2-3-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#874cc2",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0179339,
      strokeLinecap: "round",
      strokeMiterlimit: 2,
      strokeDasharray: "none"
    },
    d: "m 73.559432,147.34073 -0.87325,2.62535 c -0.14704,0.36626 -0.18034,0.42064 -0.53556,0.54174 l -2.45749,0.83787 c -0.59537,0.16438 -0.54892,0.0617 -0.55553,-0.39717 l -2.7e-4,-3.57124 c 0.005,-0.62663 0.0123,-0.57619 0.58278,-0.58783 l 3.43987,-0.003 c 0.41655,-3.8e-4 0.56601,0.0125 0.39945,0.55484 z",
    id: "path24191-5-4-2-99-0-9-8-2-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#267733",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0181549,
      strokeLinecap: "round",
      strokeMiterlimit: 2,
      strokeDasharray: "none"
    },
    d: "m 74.085982,147.35063 -0.92931,2.77629 c -0.0924,0.37327 -0.0817,0.42017 0.19506,0.69512 l 2.83974,2.87387 c 0.34403,0.31966 0.43492,0.20832 0.43753,-0.22686 l -0.003,-6.08401 c -0.002,-0.62067 0.008,-0.58459 -0.60104,-0.59616 l -1.15052,-0.003 c -0.68814,0.002 -0.58555,-0.005 -0.78811,0.56424 z",
    id: "path24191-4-7-9-7-3-7-9-6-0-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3cba50",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0179624,
      strokeLinecap: "round",
      strokeMiterlimit: 2,
      strokeDasharray: "none"
    },
    d: "m 74.080042,147.33872 -0.89938,2.65784 c -0.0924,0.36539 -0.0817,0.39635 0.19506,0.66549 l 2.84723,2.82819 c 0.34403,0.31291 0.3975,0.26382 0.40011,-0.1622 l -0.003,-5.95564 c -0.002,-0.60757 0.008,-0.57225 -0.60104,-0.58357 l -1.15052,-0.003 c -0.68814,0.002 -0.58555,-0.005 -0.78811,0.55235 z",
    id: "path24191-4-7-9-7-3-7-8-96-2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTricolor);
export default __webpack_public_path__ + "static/media/tricolor.bd7c9679c5421c9e21b40771e014da4d.svg";
export { ForwardRef as ReactComponent };